export default "__VITE_ASSET__BLK3Njzi__"